module.exports = __webpack_public_path__ + "static/media/011.963452a8.jpg";